import { Environment, MovinmotionApplication } from '../models/environment';

export const environment: Environment = {
  environment: 'develop',
  production: true,
  api: {
    movinmotionBackend: 'https://back.app.develop.movinmotion.net',
    movinmotionService: 'https://services.develop.movinmotion.net',
  },
  appEndpoints: {
    talents: '/api/talent/v1',
    core: '/api/core/v1',
    filmfrance: 'api/filmfrance/v1',
    nda: '/api/nda/v1',
    movinmotion: '/api/movinmotion/v1',
  },
  authentication: {
    url: 'https://accounts.app.develop.movinmotion.net',
    sessionExpiredPath: '/session-expired',
    queryParamKeys: {
      redirectUrl: 'mmr',
      resetPassword: 'mmrp',
      changePassword: 'mmcp',
      email: 'mme',
      language: 'mml',
      display: 'mmd',
    },
  },
  apps: {
    core: 'https://entreprise.app.develop.movinmotion.net',
    employeur: 'https://employeur.app.develop.movinmotion.net',
    worker: 'https://salarie.app.develop.movinmotion.net',
    compta: 'https://compta.app.develop.movinmotion.net',
    talents: 'https://talents.app.develop.movinmotion.net',
    insurance: 'https://assurance.app.develop.movinmotion.net',
    socialPlay: 'https://app.develop.movinmotion.net',
    social: 'https://social.app.develop.movinmotion.net',
    admin: 'https://admin.app.develop.movinmotion.net',
    movinmotion: 'https://www.movinmotion.com',
  },
  movinmotionAppUrls: {
    [MovinmotionApplication.core]: 'https://entreprise.app.develop.movinmotion.net',
    [MovinmotionApplication.accounting]: 'https://compta.app.develop.movinmotion.net',
    [MovinmotionApplication.worker]: 'https://salarie.app.develop.movinmotion.net',
    [MovinmotionApplication.social]: 'https://app.develop.movinmotion.net',
    [MovinmotionApplication.nda]: 'https://social.app.develop.movinmotion.net',
    [MovinmotionApplication.talents]: 'https://talents.app.develop.movinmotion.net',
    [MovinmotionApplication.odalie]: 'https://odalie2.app.develop.movinmotion.net',
    [MovinmotionApplication.adminBo]: 'https://admin.app.develop.movinmotion.net',
  },
  thirdParty: {
    siren: {
      endpoint: 'https://api.insee.fr/api-sirene/3.11',
      token: '30bb2afa-df6f-4447-bb2a-fadf6f144710',
    },
    googlePlaces: 'AIzaSyBzYCnxbuPu4vdArkXrRWor2Ji8xdT8rKQ',
    yousign: {
      sandbox: true,
    },
    mixpanel: {
      token: '668a9eba9515c4e5bacd50ebbb8adee5',
      name: 'MM test',
    },
  },
  bucket: {
    avatars: 'avatars.storage.develop.movinmotion.net',
  },
  cookieDomain: '.app.develop.movinmotion.net',
  captcha: { enabled: true, siteKey: '6Lcmbm0sAAAAAJcNxrSLrieOvX-hUVvHueHrMsdy' },
  featureToggles: { monCompte: true },
};
